let elements = {
  mainImage: {
    imagePath: 'games/page020_game1/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  icons: {
    negative: 'games/page020_game1/img/t.png',
    positive: 'games/page020_game1/img/f.png',
  },
  withoutCheck: false,
  maxLength: 1,
  audio: {
    negative: 'games/page020_game1/audio/f.mp3',
    positive: 'games/page020_game1/audio/t.mp3',
  },
  pick: 10,
  questions: [
    {
      src: 'games/page020_game1/img/0.png',
      correct: '0',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/1.png',
      correct: '1',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/2.png',
      correct: '2',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/3.png',
      correct: '3',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/4.png',
      correct: '4',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/5.png',
      correct: '5',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/6.png',
      correct: '6',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/7.png',
      correct: '7',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/8.png',
      correct: '8',
      width: 400,
    },
    {
      src: 'games/page020_game1/img/9.png',
      correct: '9',
      width: 400,
    },
  ],
};

export default elements;
